import type { NextPage } from 'next'

import TrustCenterView from '../views/TrustCenter'

const Sustainability: NextPage = () => <TrustCenterView />

export default Sustainability
